'use client';

import React from 'react';
import './SkeletonLoader.css';

export const ProductCardSkeleton = () => (
  <div className="skeleton-card" data-testid="skeleton-card">
    <div className="skeleton skeleton-card-image" />
    <div className="skeleton-card-body">
      <div className="skeleton skeleton-tag" />
      <div className="skeleton skeleton-title" />
      <div className="skeleton skeleton-desc" />
      <div className="skeleton skeleton-desc short" />
      <div className="skeleton-bottom">
        <div className="skeleton skeleton-price" />
        <div className="skeleton skeleton-location" />
      </div>
    </div>
  </div>
);

export const TextSkeleton = ({ width = '100%', height = '16px', style }) => (
  <div
    className="skeleton skeleton-text"
    style={{ width, height, ...style }}
    data-testid="skeleton-text"
  />
);

export const AvatarSkeleton = ({ size = 'md' }) => (
  <div
    className={`skeleton skeleton-avatar ${size}`}
    data-testid="skeleton-avatar"
  />
);

export const SkeletonGrid = ({ count = 8 }) => (
  <div className="skeleton-grid" data-testid="skeleton-grid">
    {Array.from({ length: count }).map((_, i) => (
      <ProductCardSkeleton key={i} />
    ))}
  </div>
);

export default SkeletonGrid;
